module.exports = __webpack_public_path__ + "img/superpowers_cn.40c3e74.jpg";